'use client';

import Image from 'next/image';

export function ScreenLoader() {
  return (
    <div className="flex flex-col items-center gap-2 justify-center fixed inset-0 z-50 transition-opacity duration-700 ease-in-out">
      <Image
        src="/images/ozclub-logo-dark.png"
        alt="Oz Club"
        height={36}
        width={120}
        style={{ objectFit: 'contain' }}
      />
      <div className="text-muted-foreground font-medium text-sm">
        Loading...
      </div>
    </div>
  );
}
